export interface LayerData {
  id: string;
  targetHex: string;
  paths: string[];
  d: string;
}

export function parseDailySvg(svgString: string): LayerData[] {
  // console.log("\n=== PARSER START ===");
  // console.log(`Downloaded SVG Length: ${svgString.length} characters`);

  const groups: Record<string, LayerData> = {};

  // 1. Extract <style> blocks
  const styleRegex = /<style[^>]*>([\s\S]*?)<\/style>/gi;
  let styleContent = "";
  let styleMatch;
  let styleBlockCount = 0;

  while ((styleMatch = styleRegex.exec(svgString)) !== null) {
    styleBlockCount++;
    styleContent += styleMatch[1] + "\n";
  }

  // console.log(`Found ${styleBlockCount} <style> block(s).`);
  // console.log("Raw Extracted Style Content:\n", styleContent.trim());

  // 2. Extract colors
  const colorDict: Record<string, string> = {};
  const classRegex = /\.([a-zA-Z0-9_-]+)\s*\{[^}]*fill\s*:\s*(#[0-9a-fA-F]{6}|#[0-9a-fA-F]{3})/gi;

  let match;
  while ((match = classRegex.exec(styleContent)) !== null) {
    colorDict[match[1]] = match[2];
  }

  // console.log("\nParsed Color Dictionary:");
  // console.log(JSON.stringify(colorDict, null, 2));

  // if (Object.keys(colorDict).length === 0) {
  //   console.warn("WARNING: Zero colors extracted! Regex failed to match the style content.");
  // }

  // 3. Extract paths
  const pathRegex = /<path[^>]*>/gi;
  let pathMatch;
  let pathCount = 0;

  while ((pathMatch = pathRegex.exec(svgString)) !== null) {
    pathCount++;
    const pathDom = pathMatch[0];
    const classMatch = pathDom.match(/class="([^"]+)"/i) || pathDom.match(/class='([^']+)'/i);
    const dMatch = pathDom.match(/d="([^"]+)"/i) || pathDom.match(/d='([^']+)'/i);

    if (classMatch && classMatch[1] && dMatch && dMatch[1]) {
      const classNames = classMatch[1].split(/\s+/);
      for (const className of classNames) {
        if (colorDict[className]) {
          if (!groups[className]) {
            groups[className] = {
              id: className,
              targetHex: colorDict[className],
              paths: [],
              d: ""
            };
          }
          groups[className].paths.push(dMatch[1]);
          groups[className].d += (groups[className].d ? ' ' : '') + dMatch[1];
          break;
        }
      }
    }
  }

  // console.log(`\nFound ${pathCount} <path> elements.`);

  const finalLayers = Object.values(groups);
  // console.log(`Final Grouped Layers (UI Objects): ${finalLayers.length}`);

  // finalLayers.forEach(layer => {
  //   console.log(`- Layer: ${layer.id} | Hex: ${layer.targetHex} | Paths Merged: ${layer.paths.length}`);
  // });
  // console.log("=== PARSER END ===\n");

  return finalLayers;
}

export function getSvgDimensions(svgString: string): { width: number; height: number } {
  // Try to match viewBox="0 0 width height"
  const viewBoxMatch = svgString.match(/viewBox=["']0\s+0\s+(\d+(?:\.\d+)?)\s+(\d+(?:\.\d+)?)["']/i);
  if (viewBoxMatch) {
    return { width: parseFloat(viewBoxMatch[1]), height: parseFloat(viewBoxMatch[2]) };
  }
  // Fallback to width/height attributes if viewBox is missing or different format
  const widthMatch = svgString.match(/width=["'](\d+(?:\.\d+)?)["']/i);
  const heightMatch = svgString.match(/height=["'](\d+(?:\.\d+)?)["']/i);
  if (widthMatch && heightMatch) {
    return { width: parseFloat(widthMatch[1]), height: parseFloat(heightMatch[2]) };
  }
  return { width: 800, height: 1067 }; // Default portrait aspect
}